import { GATEWAY } from "./const";
import {
  TFilterRequestBody,
  TListing,
  TMarketplaceListingResponse,
  TMetadata,
  TStoreItem,
} from "../types/types";
import { currentChain, currentChainId } from "./chain";
import { EnumCurrencyType } from "@uicomps/common/helpers";
import { EPackageSize } from "@overlay/types/enums";
import { EChainId } from "@shared/types";
import { Console } from "console";

export async function getMarketplaceListings(
  filters: TFilterRequestBody,
  pageNumber = 0,
): Promise<TMarketplaceListingResponse | void> {
  if (filters.chain == "Casper") {
    return await getCasperListings();
  } else if (filters.chain == "") {
    if (currentChainId.value == EChainId.CSPR) {
      return await getCasperListings();
    }
  }
  try {
    let chainId;
    if (filters.chain == "BSC" || filters.chain == "") {
      chainId = 56;
    }
    return await (
      await fetch(`${GATEWAY}/listing/page/${pageNumber}?chain-id=${chainId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(filters),
      })
    ).json();
  } catch (e) {
    console.error(e);
  }
}

export async function getListingsBySeller(
  seller: string,
): Promise<Array<TListing> | void> {
  try {
    return await (
      await fetch(
        `${GATEWAY}/listing/seller/${seller}?chain-id=${currentChain.value.chain_id}`,
        {
          method: "GET",
        },
      )
    ).json();
  } catch (e) {
    console.error(e);
  }
}

export async function getShopItems(
  theme: string,
): Promise<Array<TStoreItem> | void> {
  try {
    const result = await (
      await fetch(`${GATEWAY}/shop/collection/${theme}`, {
        method: "GET",
      })
    ).json();
    return result.map((element) => {
      return {
        ...element,
        metadata:
          typeof element.metadata === "object"
            ? element.metadata
            : JSON.parse(element.metadata),
      };
    });
  } catch (e) {
    console.error(e);
  }
}

export async function buyCollection(
  signedMessage: string,
  userId: string,
  collectionAddress: string,
  currency: EnumCurrencyType,
  wallet: string,
): Promise<{
  tokenId: number;
  txHash: any;
}> {
  const body = JSON.stringify({
    signedMessage,
    userId,
    collectionAddress,
    currency,
    wallet,
  });
  const response = await fetch(`${GATEWAY}/shop/buy`, {
    method: "POST",
    body,
    headers: {
      "Content-Type": "application/json",
    },
  });
  const jsonResponse = await response.json();
  if (response.status == 201) {
    return jsonResponse;
  }
  throw new Error(`${jsonResponse.message}`);
}

export async function createTransaction(
  packageSize: string,
  userId: string,
): Promise<{ paymentURL: string }> {
  return await (
    await fetch(
      `${GATEWAY}/payment/createTransaction?bthPackage=${packageSize}&userId=${userId}`,
    )
  ).json();
}

export async function getBthPackages(): Promise<
  Array<{ id: EPackageSize; name: string; tokens: number; price: number }>
> {
  return await (await fetch(`${GATEWAY}/payment/package`)).json();
}

export async function getCasperListings() {
  const res = await (
    await fetch(
      "https://us-central1-abiding-arch-334410.cloudfunctions.net/getListings",
    )
  ).json();
  const listings = res.map(
    (listing: {
      id: number;
      owner: string;
      tokenId: number;
      price: number;
      status: string;
      collection: { hash: string };
      nft: {
        id: string;
        tokenId: number;
        metadata: string;
      };
    }): TListing => {
      const metadata: TMetadata = JSON.parse(listing.nft.metadata);
      return {
        listingId: listing.id,
        seller: listing.owner,
        price: listing.price,
        timeAdded: new Date(),
        timeExecuted: new Date(),
        timeCancelled: new Date(),
        buyer: "",
        status: listing.status,
        nftId: 1,
        chainId: 1,
        nft: {
          address: listing.collection.hash,
          metadata: {
            id: 22,
            data: metadata,
            url: metadata.external_link,
          },
          tokenId: listing.tokenId,
          collection: {
            address: listing.collection.hash,
            category: {
              id: 22,
              name: "character",
            },
          },
        },
      };
    },
  );
  return {
    listings,
    count: listings.length,
  };
}
